/*
  Dolls Karma — motion layer
  - ScrollSmoother: slow/luxe smooth scroll (desktop, motion-OK only)
  - data-speed parallax (e.g. the hero panel) via ScrollSmoother effects
  - .dk-reveal: staggered fade/rise on scroll (manifesto, lookbook, products…)
  - .dk-seam[data-reveal]: hairline draws itself in (scaleX 0 → 1)

  Progressive enhancement: initial hidden states are set in JS, never in CSS,
  so if GSAP fails to load the content simply shows with no animation.
*/
(function () {
  'use strict';

  var gsap = window.gsap;
  if (!gsap) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 720px)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);
  if (window.ScrollSmoother) gsap.registerPlugin(window.ScrollSmoother);

  // In the theme editor or with reduced motion, keep everything visible & still.
  if (reduce || designMode) {
    gsap.set('.dk-reveal', { opacity: 1, y: 0 });
    gsap.set('.dk-seam[data-reveal]', { scaleX: 1 });
    return;
  }

  // Smooth scroll — desktop only (mobile keeps native scroll: "efektleri hafiflet").
  if (!isMobile && window.ScrollSmoother && document.getElementById('smooth-wrapper')) {
    window.ScrollSmoother.create({
      wrapper: '#smooth-wrapper',
      content: '#smooth-content',
      smooth: 1.4,
      effects: true,          // activates data-speed / data-lag parallax
      normalizeScroll: true
    });
  }

  if (!window.ScrollTrigger) return;
  var ScrollTrigger = window.ScrollTrigger;

  // Staggered reveals
  gsap.utils.toArray('.dk-reveal').forEach(function (el) {
    gsap.set(el, { opacity: 0, y: 44 });
    ScrollTrigger.create({
      trigger: el,
      start: 'top 86%',
      once: true,
      onEnter: function () {
        gsap.to(el, { opacity: 1, y: 0, duration: 1.25, ease: 'power3.out' });
      }
    });
  });

  // Hairline seams draw in
  gsap.utils.toArray('.dk-seam[data-reveal]').forEach(function (el) {
    gsap.set(el, { scaleX: 0, transformOrigin: 'left' });
    ScrollTrigger.create({
      trigger: el,
      start: 'top 90%',
      once: true,
      onEnter: function () {
        gsap.to(el, { scaleX: 1, duration: 1.6, ease: 'power2.inOut' });
      }
    });
  });
})();
